let EVENT_TYPES = /** @type {const} */ ({
  appointment_bookings_state_update: 'Appointment Status',
  txs_status_update: 'Treatment Status',
  custom_resource_insert: 'Custom Resource Created',
  patient_demographics_changed: 'Patient demographics changed',
  contract_signed: 'Contract signed',
  document_signed: 'Document signed',
  order_status_changed: 'Order status changed',
  medical_form_submitted: 'Medical form submitted',
})

export function getTitle(event_type) {
  return `Automate ${EVENT_TYPES[event_type].toLowerCase() ?? ''} workflow`
}
